import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './components/Auth/Login';
import Dashboard from './components/Dashboard/Dashboard';
import UserList from './components/Users/UserList';
import WarehouseDetail from './components/Warehouses/WarehouseDetail';
import Planning from './components/Planning/Planning';
import AmazonWarehouse from './components/Warehouses/Amazon/AmazonWarehouse';
import Sales from './components/Sales/Sales';
import Manufacturing from './components/Manufacturing/Manufacturing';
import ShippingTable from './components/Shipping/ShippingTable'; // ✅ New import
import FactoryShipments from './components/FactoryShipments/FactoryShipments';

import './App.css';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

// Main App Component
const AppContent = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />

      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />

      <Route
        path="/users"
        element={
          <ProtectedRoute>
            <UserList />
          </ProtectedRoute>
        }
      />

      <Route
        path="/warehouse/:warehouseId"
        element={
          <ProtectedRoute>
            <WarehouseDetail />
          </ProtectedRoute>
        }
      />

      <Route
        path="/planning"
        element={
          <ProtectedRoute>
            <Planning />
          </ProtectedRoute>
        }
      />

      <Route
        path="/amazon"
        element={
          <ProtectedRoute>
            <AmazonWarehouse />
          </ProtectedRoute>
        }
      />

      <Route
        path="/sales"
        element={
          <ProtectedRoute>
            <Sales />
          </ProtectedRoute>
        }
      />

      <Route
        path="/manufacturing"
        element={
          <ProtectedRoute>
            <Manufacturing />
          </ProtectedRoute>
        }
      />

      {/* 🚚 New Shipping Route */}
      <Route
        path="/shipping"
        element={
          <ProtectedRoute>
            <ShippingTable />
          </ProtectedRoute>
        }
      />

        <Route
      path="/factory-shipments"
      element={
        <ProtectedRoute>
          <FactoryShipments />
        </ProtectedRoute>
      }
    />


      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <AppContent />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
